import { platform } from '../Platform';
import { getPlayerUuid } from '../Signage/utility';
import { Log } from '../AuxillaryService/Log';
import { setReachIamInstance } from './instance';
import { assert } from '../Utility/assert';

export async function configureReachIam(): Promise<void> {
    assert(
        typeof process.env.BASE_URL_API_V2 === 'string' &&
            typeof process.env.REACH_IAM_CLIENT_ID === 'string' &&
            typeof process.env.REACH_IAM_CLIENT_SECRET === 'string' &&
            typeof process.env.REACH_IAM_SHARED_SECRET === 'string',
        'Environment variables not set.'
    );

    const playerUuid = getPlayerUuid();
    assert(typeof playerUuid === 'string', 'Player UUID not set.');

    setReachIamInstance({
        baseUrl: process.env.BASE_URL_API_V2,
        clientId: process.env.REACH_IAM_CLIENT_ID,
        clientSecret: process.env.REACH_IAM_CLIENT_SECRET,
        sharedSecret: process.env.REACH_IAM_SHARED_SECRET,
        playerUuid: playerUuid,
        hardwareId: await platform().getHardwareId(),
        log: Log,
    });
}
